import React, { cloneElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, HeartIcon, UsersIcon, ZapIcon, StarIcon } from 'lucide-react';
import { SEO } from '../components/SEO';
import { openingHours } from '../data/businessInfo';
export const OverOnsPage = () => {
  return <main className="bg-[#0a0a0a]" data-id="element-1556" data-mp="7oz7ry7nzpvy">
      <SEO title="Over Ons | BKCustoms Car Styling Almere" description="Ontdek het verhaal achter BKCustoms in Almere. Gedreven door passie voor auto's en persoonlijke service, transformeren we voertuigen sinds 2020." canonical="/over-ons" data-id="element-1557" data-mp="7q0iu2ookcdo" />
      {/* Hero Section - More Personal Approach */}
      <section className="relative overflow-hidden" data-id="element-1558" data-mp="mf6hnpjlw0l1">
        {/* Background with parallax effect */}
        <div className="absolute inset-0 z-0" data-id="element-1559" data-mp="qenpgpmi99td">
          <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black/70 z-10" data-id="element-1560" data-mp="qhjka5323idl"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats" className="w-full h-full object-cover object-center" data-id="element-1561" data-mp="10dwfj7e924ag" />
        </div>
        <div className="relative z-10 pt-40 pb-24 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1562" data-mp="q4vf85vm4gd0">
          <div className="max-w-3xl" data-id="element-1563" data-mp="m2ql76195hpu">
            {/* Logo */}
            <div className="mb-8" data-id="element-1564" data-mp="m3a34mqwk63v">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adgHjwdfFHAKcJTTi1A4e1/BK-Customs-Logo-DEF-01.png" alt="BKCustoms Logo" className="h-32 w-auto" data-id="element-1565" data-mp="h46wwyz6rtub" />
            </div>
            {/* Subtle badge */}
            <div className="inline-flex items-center bg-white/5 backdrop-blur-sm rounded-full py-1.5 px-3 mb-6" data-id="element-1566" data-mp="19sci1mu5jkuo">
              <span className="text-white/80 text-xs font-medium tracking-wide" data-id="element-1567" data-mp="150ukz9v924ez">
                SINDS 2020 • ALMERE
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" data-id="element-1568" data-mp="1xi6wg8u4dhh1">
              Het verhaal
              <br data-id="element-1569" data-mp="1sqx7zbkb4k6q" />
              achter <span className="text-[#D6281F]" data-id="element-1570" data-mp="1sqotjf8jd6tf">BKCustoms</span>
            </h1>
            <p className="text-xl text-white/80 leading-relaxed mb-8 font-light" data-id="element-1571" data-mp="2bnfjlpwwuteh">
              Waar passie voor auto's en vakmanschap samenkomen
            </p>
          </div>
        </div>
        {/* Decorative element */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-1572" data-mp="22um2dmxwljxz"></div>
      </section>
      {/* Our Story Section - More Visual */}
      <section className="py-20 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1573" data-mp="1swy2kilfxm8y">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1574" data-mp="1xw10zk6x0u7y">
          <div className="order-2 lg:order-1" data-id="element-1575" data-mp="1xty0u7c1tkpi">
            <h2 className="text-4xl font-bold text-white mb-8 leading-tight" data-id="element-1576" data-mp="1jxkv1vgvn7qv">
              Gedreven door <span className="text-[#D6281F]" data-id="element-1577" data-mp="1nxcw7n3xybm7">passie</span>
            </h2>
            <div className="prose prose-lg prose-invert" data-id="element-1578" data-mp="3eatwczz9rmy1">
              <p className="text-white/80 text-lg leading-relaxed mb-6" data-id="element-1579" data-mp="3ebc00ho9h3fz">
                BKCustoms is ontstaan uit pure liefde voor auto's. Met meer dan
                10 jaar ervaring in de branche, besloten we in 2020 onze eigen
                droom te verwezenlijken: een plek creëren waar auto's worden
                getransformeerd met precisie, creativiteit en toewijding.
              </p>
              <p className="text-white/80 text-lg leading-relaxed" data-id="element-1580" data-mp="1gfwunchsb36q">
                Bij ons draait alles om jouw wensen. We luisteren, adviseren en
                werken samen om jouw auto de unieke uitstraling te geven die
                perfect bij jou past.
              </p>
            </div>
            <Link to="/afspraak-maken" className="inline-flex items-center bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 mt-8 group border border-white/10" data-id="element-1581" data-mp="1ldf557bg9qgu">
              <span className="mr-2" data-id="element-1582" data-mp="1uf67c26s7f5y">Maak kennis met ons team</span>
              <ArrowRightIcon size={16} className="transition-transform duration-300 group-hover:translate-x-1" data-id="element-1583" data-mp="50hvq360m18z" />
            </Link>
          </div>
          {/* Visual element */}
          <div className="order-1 lg:order-2" data-id="element-1584" data-mp="2fjzatj3ot6d">
            <div className="relative" data-id="element-1585" data-mp="2er0qfuap9zb">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1586" data-mp="6gc9bozsr23p"></div>
              <div className="relative h-[500px] overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1587" data-mp="bg8cjm0o6pi7">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/epTaMYxL4anUJLdbRfE6sf/Afbeelding-van-WhatsApp-op-2024-09-11-om-03.56.27_c7bf755e.jpg" alt="Auto styling met passie" className="w-full h-full object-cover object-center" data-id="element-1588" data-mp="ge0e77r49pzl" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-1589" data-mp="3ou3c4lsfg0aq"></div>
                {/* Quote overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-1590" data-mp="3tmms1pel77ip">
                  <blockquote className="italic text-white text-lg font-light" data-id="element-1591" data-mp="2w54qvft0ci17">
                    "Elke auto vertelt een verhaal. Wij helpen dat verhaal vorm
                    te geven."
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values Section - More Creative */}
      <section className="py-20 bg-[#0f0f0f] relative overflow-hidden" data-id="element-1592" data-mp="2jmsnqy9z1zjh">
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre-v2.png')]" data-id="element-1593" data-mp="2ep0kx97sgt0i"></div>
        <div className="relative z-10 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1594" data-mp="2anyikjiks0ub">
          <div className="text-center mb-16" data-id="element-1595" data-mp="25v5ezyyueyjt">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1596" data-mp="20wu4dm0q4k0j">
              Waar wij voor <span className="text-[#D6281F]" data-id="element-1597" data-mp="20uq2taqarx3f">staan</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1598" data-mp="1vzkiggcjmqhg">
            {[{
            icon: <HeartIcon className="text-[#D6281F]" data-id="element-1599" data-mp="1qxv34oiafqnk" />,
            title: 'Passie',
            description: 'Elke auto die onze werkplaats binnenkomt, behandelen we met dezelfde toewijding als onze eigen voertuigen.'
          }, {
            icon: <StarIcon className="text-[#D6281F]" data-id="element-1600" data-mp="1hasmpcqjpnxw" />,
            title: 'Kwaliteit',
            description: 'We werken uitsluitend met premium materialen en technieken voor een resultaat waar je trots op kunt zijn.'
          }, {
            icon: <UsersIcon className="text-[#D6281F]" data-id="element-1601" data-mp="18b5hsgyly003" />,
            title: 'Persoonlijk',
            description: 'Jouw wensen staan centraal. We luisteren, adviseren en creëren samen jouw ideale auto.'
          }, {
            icon: <ZapIcon className="text-[#D6281F]" data-id="element-1602" data-mp="200qppefhkquo" />,
            title: 'Innovatie',
            description: 'We blijven continu op de hoogte van de nieuwste trends en technieken in car styling.'
          }].map((value, index) => <div key={index} className="bg-gradient-to-br from-[#0a0a0a] to-[#151515] p-8 rounded-lg border border-white/5 hover:border-white/10 transition-all duration-300 group" data-id="element-1603" data-mp="1r6vnof9nvgj9" data-mpi={index}>
                <div className="bg-black/30 p-4 rounded-full inline-flex mb-6 group-hover:bg-[#D6281F]/20 transition-colors duration-300" data-id="element-1604" data-mp="2jrm2aop0r6tt">
                  {cloneElement(value.icon, {
                size: 28
              })}
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-1605" data-mp="32ue4h7wc0zk9">
                  {value.title}
                </h3>
                <p className="text-white/70" data-id="element-1606" data-mp="2xwcmkqan76ad">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Customer Stories Section */}
      <section className="py-20 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1607" data-mp="264di1fjfqv64">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-1608" data-mp="26686h3tx15ey">
          <div className="w-full lg:w-1/2" data-id="element-1609" data-mp="2k57qfy6hgw4s">
            <div className="relative" data-id="element-1610" data-mp="2f4ti0f0yzk68">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] to-[#FF6B00] opacity-30 blur-lg rounded-lg" data-id="element-1611" data-mp="2f3sagkj5xft9"></div>
              <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1612" data-mp="3vkwe6rrk9z6n">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3v8Pos7TXNGtqMbGvoXuvd/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_fb59bef4.jpg" alt="Tevreden klant met Mercedes-AMG bij BKCustoms" className="w-full h-auto object-cover" data-id="element-1613" data-mp="3qm31h1k3mc7j" />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-1614" data-mp="1xtemvtst20af">
            <h2 className="text-4xl font-bold text-white mb-8 leading-tight" data-id="element-1615" data-mp="22mzjpiinwo81">
              Jij staat <span className="text-[#D6281F]" data-id="element-1616" data-mp="27lu06dt5q0oz">centraal</span>
            </h2>
            <div className="prose prose-lg prose-invert" data-id="element-1617" data-mp="2cjvjmzuhw20z">
              <p className="text-white/80 text-lg leading-relaxed mb-6" data-id="element-1618" data-mp="2ciaq9djx2p4p">
                Bij BKCustoms draait alles om jou en jouw auto. We nemen de tijd
                om te luisteren naar jouw wensen en ideeën, en vertalen deze
                naar een eindresultaat dat jouw verwachtingen overtreft.
              </p>
              <p className="text-white/80 text-lg leading-relaxed" data-id="element-1619" data-mp="ma2ekqk9fl5z">
                Of je nu op zoek bent naar subtiele verfijning of een complete
                transformatie, ons team staat klaar om jouw auto de aandacht te
                geven die het verdient.
              </p>
            </div>
            <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-1620" data-mp="euqgwxw05bqs">
              <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1621" data-mp="9y020dvxom6y">
                <span className="mr-2" data-id="element-1622" data-mp="12k1gwd5j323v">Maak een afspraak</span>
                <ArrowRightIcon size={16} data-id="element-1623" data-mp="xocg66hrvf5z" />
              </Link>
              <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1624" data-mp="snogkwfh9q05">
                Neem contact op
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Location Section */}
      <section className="py-20 bg-[#0f0f0f] relative overflow-hidden" data-id="element-1625" data-mp="39eokdnim86cd">
        <div className="relative z-10 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1626" data-mp="19vpapk0b7iw9">
          <div className="text-center mb-12" data-id="element-1627" data-mp="15u3vvt47sujf">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1628" data-mp="15r7ws1gmrzte">
              Bezoek onze <span className="text-[#D6281F]" data-id="element-1629" data-mp="1jma7d1wfadcj">werkplaats</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto" data-id="element-1630" data-mp="1esfpm40do8g3">
              Kom langs voor een persoonlijk advies of om je auto te laten
              transformeren door ons team van specialisten.
            </p>
          </div>
          <div className="bg-[#0a0a0a] rounded-lg overflow-hidden border border-white/10" data-id="element-1631" data-mp="1om4xh38diywj">
            <div className="aspect-w-16 aspect-h-9 h-[400px]" data-id="element-1632" data-mp="22hh2c3g8u5r6">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats in Almere" className="w-full h-full object-cover" data-id="element-1633" data-mp="1xls17voksgsr" />
            </div>
            <div className="p-8 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-1634" data-mp="380najz7rari">
              <div data-id="element-1635" data-mp="2euchd4whx82j">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-1636" data-mp="2evvxmvi5jj4b">
                  BKCustoms Almere
                </h3>
                <p className="text-white/70" data-id="element-1637" data-mp="261r1bwk91fhe">
                  Microfoonstraat 36, 1322 BN Almere
                </p>
                <p className="text-white/70 mt-2" data-id="element-1638" data-mp="2a2ayh04toj3j">{openingHours.short}</p>
              </div>
              <Link to="/contact" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center whitespace-nowrap" data-id="element-1639" data-mp="1w2s1n3hgou6j">
                <span className="mr-2" data-id="element-1640" data-mp="1n3y9bpb5ypys">Route plannen</span>
                <ArrowRightIcon size={16} data-id="element-1641" data-mp="1r3ynd8ucoz5b" />
              </Link>
            </div>
          </div>
          {/* Logo in footer */}
          <div className="mt-16 text-center" data-id="element-1642" data-mp="3hhpg8h23yvqj">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adgHjwdfFHAKcJTTi1A4e1/BK-Customs-Logo-DEF-01.png" alt="BKCustoms Logo" className="h-24 w-auto mx-auto" data-id="element-1643" data-mp="3hethwrmcm51k" />
          </div>
        </div>
      </section>
    </main>;
};